import script from "./TemplateMaster.vue?vue&type=script&setup=true&lang=js"
export * from "./TemplateMaster.vue?vue&type=script&setup=true&lang=js"

import "./TemplateMaster.vue?vue&type=style&index=0&id=50365c87&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-50365c87"]])

export default __exports__